import { useState } from "react";
import OpenQuickPopup from "../../../../shared/OpenQuickPopup/OpenQuickPopup";

// Custom hook for managing open tabs and handling different types of data
const useOpenTab = () => {

    // State to manage the currently open tab
    const [openTab, setOpenTab] = useState('');

    // State to manage the content of a popup
    const [popup, setPopup] = useState(<></>);

    // Function to open a patient tab
    const OpenPatient = (selectedData) => {
        let obj = {
            key: 2,
            name: "Patient",
            active: true,
            data: {
                // id: selectedData.Field1.toString(),
                id: selectedData.Field1,
                name: selectedData.FirstName,
                FullName: selectedData.Field2,
                time: new Date(),
            },
        };
        setOpenTab(obj);
    }

    // Function to open a claim tab
    const OpenClaim = (selectedData) => {
        let ClaimData = selectedData.Field2.split(',')
        let obj = {
            key: 2,
            name: "Claims",
            active: true,
            data: {
                id: selectedData.Field1.toString(),
                name: ClaimData[1],
                visitType: selectedData.Field7,
                time: new Date(),
            },
        };
        setOpenTab(obj);
    }

    // Function to open a payment tab
    const OpenPayment = (selectedData) => {
        let checkType = selectedData.Type.split(" ")?.[0]
        let obj = {
            key: 2,
            name: "Payments",
            active: true,
            data: {
                id: selectedData.Field1,
                name: selectedData.Field2,
                time: new Date(),
                checkType: checkType,
            },
        };
        setOpenTab(obj);
    }

    // Function to handle opening a QuickPopup
    const handleOpenQuickPopup = (selectedData) => {
        setPopup(<OpenQuickPopup ID={selectedData.Field1} name={selectedData.Field2} setPopup={setPopup} popupName={selectedData.Type} type={'GlobalInstantSearch'} />);
    }

    // Return the functions and states for external use
    return { openTab, setOpenTab, popup, OpenPatient, OpenClaim, OpenPayment, handleOpenQuickPopup };
}

export default useOpenTab;
